'use client';

// import { useViewColorScheme } from '@/lib/store/hooks';
import { getFragmentData } from '@/__generated__';
import { NotFoundEntryFragment } from '@/__generated__/graphql';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import { NOTFOUND_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useBreakpointMin } from '@/theme';
import Breadcrumbs from '../Breadcrumbs';
import Grid from '../ui/Grid';
import PageHeaderRoot from './PageHeaderRoot';
import PageImage from './PageImage';
import PageTitle from './PageTitle';

const PageHeaderNotFound = (props: NotFoundEntryFragment) => {
  const card = getFragmentData(NOTFOUND_CARD_FRAGMENT, props);
  const base = getFragmentData(ENTRY_BASE_FRAGMENT, card);
  const sm = useBreakpointMin('sm');

  return (
    <PageHeaderRoot
      variant="overview"
      colorSet="velvet"
      paper
      GridColProps={{ md: 8 }}
      afterCol={
        sm && (
          <Grid.Col offsetMd={1} sm={5} md={3}>
            <PageImage mask={true} data={card.entryImage} />
          </Grid.Col>
        )
      }>
      <Breadcrumbs data={base} CtaButtonProps={{ color: 'blue' }} cx={{ mB: 'xs', mT: '5xl' }} />
      <PageTitle uppercase cx={{ mB: '5xl' }}>
        {card.entryTitle}
      </PageTitle>
    </PageHeaderRoot>
  );
};

export default PageHeaderNotFound;
